import { Stack, Title } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Form from 'components/ui/Form';
import { useDevices } from 'utils/devices';

import s from './CreateForm.module.scss';

type CreateFormProps = {
  title: string;
  onSubmit: () => void;
  children: React.ReactNode;
};

const CreateForm: React.FC<CreateFormProps> = ({ title, onSubmit, children }) => {
  const { isPhone } = useDevices();

  return (
    <Stack className={s.root} component={Form} onSubmit={onSubmit} gap="md">
      <Stack gap="md" className={s.root__content}>
        <Title component="div" size={isPhone ? 'h4' : 'h3'}>
          {title}
        </Title>
        {children}
      </Stack>
    </Stack>
  );
};

export default observer(CreateForm);
